import { memo, useCallback } from 'react';

import { InfoListItem } from '@/components/molecules';

interface ContactListItemProps {
  readonly id: number;
  readonly displayName: string;
  readonly email: string | null | undefined;
  readonly personalMobileNumber: string | null | undefined;
  readonly onPress: (id: number) => void;
}

const ContactListItemBase = ({
  id,
  displayName,
  email,
  personalMobileNumber,
  onPress,
}: ContactListItemProps) => {
  const handlePress = useCallback(() => onPress(id), [onPress, id]);

  return (
    <InfoListItem
      title={displayName}
      subtitle={email}
      tertiaryText={personalMobileNumber}
      onPress={handlePress}
    />
  );
};

export const ContactListItem = memo(ContactListItemBase);
